export const ActivateSubscriptionFailModal: string = 'ActivateSubscriptionSuccessFailModal';
